/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum WebsiteWhatsAppCtaSlot {
    GENERAL_CONTACT = 'generalContact',
    PROPERTY_CARD = 'propertyCard',
    PROPERTY_DETAIL = 'propertyDetail',
    SCHEDULE_VISIT = 'scheduleVisit',
    AI_HANDOFF = 'aiHandoff',
}
